import { observable } from 'mobx';
// import { autobind } from 'core-decorators';
import { useEffect } from 'react';
import BaseStore from '@src/utils/store/base-store';
import useMount from '@src/utils/hooks/use-mount';
import BaseSwiperStore from '@src/components/swiper/base-swiper/store';
import useFunLinkPageData from '@src/utils/use-fun-link-page-data.js';

class MapStore extends BaseStore {
  // 地图数据
  @observable slidesData;

  swiperStore = new BaseSwiperStore({
    swiperOptions: {
      spaceBetween: 0,
      effect: 'fade',
      observe: true,
      observeParents: true,
      fadeEffect: {
        crossFade: true
      },
      allowTouchMove: false
    }
  });

  use() {
    super.use();
    useMount(async () => { });
    const data = useFunLinkPageData();
    useEffect(
      () => {
        if (!data) {
          return;
        }
        let result = data?.contentList.map(itemA => {
          return { ...itemA };
        });
        this.slidesData = data.contentList;
        //console.log(this.slidesData);
      },
      [data]
    );
  }
}

export default MapStore;
